/**
 * Configurations API — aircraft/vehicle variant management.
 */

import { apiClient } from "./client";

export interface Configuration {
  id: string;
  project_id: string;
  name: string;
  display_name: string | null;
  description: string | null;
  aircraft_type: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string | null;
  metadata: Record<string, unknown>;
}

export interface ConfigurationCreate {
  project_id: string;
  name: string;
  display_name?: string;
  description?: string;
  aircraft_type?: string;
}

export interface ConfigurationUpdate {
  display_name?: string;
  description?: string;
  aircraft_type?: string;
  metadata?: Record<string, unknown>;
}

export function fetchConfigurations(
  projectId: string,
): Promise<Configuration[]> {
  const params = new URLSearchParams({ project_id: projectId });
  return apiClient<Configuration[]>(`/configurations?${params}`);
}

export function createConfiguration(
  body: ConfigurationCreate,
): Promise<Configuration> {
  return apiClient<Configuration>("/configurations", {
    method: "POST",
    body,
  });
}

export function updateConfiguration(
  configId: string,
  body: ConfigurationUpdate,
): Promise<Configuration> {
  return apiClient<Configuration>(`/configurations/${configId}`, {
    method: "PUT",
    body,
  });
}

export function deleteConfiguration(configId: string): Promise<void> {
  return apiClient<void>(`/configurations/${configId}`, {
    method: "DELETE",
  });
}
